import { FolderOpen, Layers3, Shapes, Sparkles, Type, X } from 'lucide-react';
import { useEditorStore } from '../../store/editorStore';
import { EffectsPanel, TemplatesPanel, TextPanel } from '../panels/LibraryPanel';
import { LayerOutliner } from '../panels/LayerOutliner';
import { MediaPanel } from '../panels/MediaPanel';

const tabs = [
  { id: 'media' as const, label: 'Media', icon: FolderOpen },
  { id: 'layers' as const, label: 'Layers', icon: Layers3 },
  { id: 'text' as const, label: 'Text', icon: Type },
  { id: 'effects' as const, label: 'Effects', icon: Sparkles },
  { id: 'templates' as const, label: 'Presets', icon: Shapes }
];

export function LeftDock() {
  const active = useEditorStore((state) => state.leftPanel);
  const open = useEditorStore((state) => state.mobilePanelOpen);
  const setActive = useEditorStore((state) => state.setLeftPanel);
  const setOpen = useEditorStore((state) => state.setMobilePanelOpen);
  return <aside className={`left-dock ${open ? 'mobile-open' : ''}`}><button className="mobile-dock-close" onClick={() => setOpen(false)}><X size={17} /></button><div className="dock-tabs">{tabs.map(({ id, label, icon: Icon }) => <button key={id} className={active === id ? 'is-active' : ''} onClick={() => setActive(id)}><Icon size={14} />{label}</button>)}</div>
    <div className="dock-body">{active === 'media' ? <MediaPanel /> : active === 'layers' ? <LayerOutliner /> : active === 'text' ? <TextPanel /> : active === 'effects' ? <EffectsPanel /> : <TemplatesPanel />}</div>
  </aside>;
}
